// Generated by ReScript, PLEASE EDIT WITH CARE

import * as BsCss from "../../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as YearFootPrint from "./YearFootPrint.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

var container = Curry._1(BsCss.style, {
      hd: BsCss.width(BsCss.px(165)),
      tl: {
        hd: BsCss.position("absolute"),
        tl: {
          hd: BsCss.bottom(BsCss.px(0)),
          tl: {
            hd: BsCss.right(BsCss.px(70)),
            tl: {
              hd: BsCss.media("(min-width: 1200px)", {
                    hd: BsCss.right(BsCss.px(170)),
                    tl: /* [] */0
                  }),
              tl: /* [] */0
            }
          }
        }
      }
    });

var Styles = {
  container: container
};

function Year2024(props) {
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(YearFootPrint.make, {
                    title: "2024",
                    subTitle: "Today",
                    bodyText: "We become the official gifting partner of Afterpay and have over 800+ brands globally."
                  }),
              className: container
            });
}

var make = Year2024;

export {
  Styles ,
  make ,
}
/* container Not a pure module */
